export enum MaintenanceSource {
  OEM = 1,
  Custom = 2,
  System = 3,
  DriverApp = 4,
  ComplianceApp = 5,
  CanBus = 6
}